
import { useState } from 'react';

export interface AiChatMessage {
  question: string;
  answer: string;
}

export const useAiChat = () => {
  const [aiChat, setAiChat] = useState<AiChatMessage[]>([]);

  const handleAiQuestion = (question: string) => {
    setAiChat(prev => [...prev, { question, answer: '' }]);
  };

  const handleAiResponse = (response: string) => {
    setAiChat(prev => {
      const updated = [...prev];
      if (updated.length > 0) {
        updated[updated.length - 1].answer = response;
      }
      return updated;
    });
  };

  return {
    aiChat,
    handleAiQuestion,
    handleAiResponse
  };
};
